import { jsx as _jsx } from "react/jsx-runtime";
import { OpenFaireDirectFirstOrderIncentiveModalButton } from "@faire/retailer-visitor-shared/components/Notifications/Components/FaireDirectIncentivesBanner/FaireDirectFirstOrderIncentiveBanner/__internal__/OpenFaireDirectFirstOrderIncentiveModalButton";
import { useFaireDirectFirstOrderIncentive } from "@faire/retailer-visitor-shared/hooks/FaireDirect/useFaireDirectFirstOrderIncentive/useFaireDirectFirstOrderIncentive";
import { MediumFormatting } from "@faire/web--source/common/localization/formatting";
import { Typography } from "@faire/web--source/slate/Typography";
import { StrictLocalMsg } from "@faire/web--source/ui/lib/localization";
import { observer } from "mobx-react";
import * as React from "react";
var FaireDirectFirstOrderIncentiveBannerBase = function() {
    var _useFaireDirectFirstOrderIncentive = useFaireDirectFirstOrderIncentive(), brandName = _useFaireDirectFirstOrderIncentive.brandName, isLastDayBeforeExpiry = _useFaireDirectFirstOrderIncentive.isLastDayBeforeExpiry, isSecondLastDayBeforeExpiry = _useFaireDirectFirstOrderIncentive.isSecondLastDayBeforeExpiry, isFaireDirectCreditPercentageBased = _useFaireDirectFirstOrderIncentive.isFaireDirectCreditPercentageBased, formattedFixedBasedAmount = _useFaireDirectFirstOrderIncentive.formattedFixedBasedAmount, formattedPercentageBasedNumber = _useFaireDirectFirstOrderIncentive.formattedPercentageBasedNumber;
    if (isFaireDirectCreditPercentageBased) {
        if (isLastDayBeforeExpiry) {
            return /*#__PURE__*/ _jsx(BannerWrapper, {
                children: /*#__PURE__*/ _jsx(StrictLocalMsg, {
                    id: "nY9MvF",
                    defaultMessage: [
                        {
                            type: 8,
                            value: "MediumFormatting",
                            children: [
                                {
                                    type: 0,
                                    value: "Last day!"
                                }
                            ]
                        },
                        {
                            type: 0,
                            value: " Get "
                        },
                        {
                            type: 1,
                            value: "percentageBasedNumber"
                        },
                        {
                            type: 0,
                            value: " off & free shipping with "
                        },
                        {
                            type: 1,
                            value: "brandCompanyName"
                        },
                        {
                            type: 0,
                            value: ". "
                        },
                        {
                            type: 8,
                            value: "IncentiveModalOpenLinkFormatting",
                            children: [
                                {
                                    type: 0,
                                    value: "View details"
                                }
                            ]
                        }
                    ],
                    values: {
                        MediumFormatting: MediumFormatting,
                        IncentiveModalOpenLinkFormatting: OpenFaireDirectFirstOrderIncentiveModalButton,
                        percentageBasedNumber: formattedPercentageBasedNumber,
                        brandCompanyName: brandName !== null && brandName !== void 0 ? brandName : ""
                    }
                })
            });
        } else if (isSecondLastDayBeforeExpiry) {
            return /*#__PURE__*/ _jsx(BannerWrapper, {
                children: /*#__PURE__*/ _jsx(StrictLocalMsg, {
                    id: "h4xXFU",
                    defaultMessage: [
                        {
                            type: 8,
                            value: "MediumFormatting",
                            children: [
                                {
                                    type: 0,
                                    value: "2 days left!"
                                }
                            ]
                        },
                        {
                            type: 0,
                            value: " Get "
                        },
                        {
                            type: 1,
                            value: "percentageBasedNumber"
                        },
                        {
                            type: 0,
                            value: " off & free shipping with "
                        },
                        {
                            type: 1,
                            value: "brandCompanyName"
                        },
                        {
                            type: 0,
                            value: ". "
                        },
                        {
                            type: 8,
                            value: "IncentiveModalOpenLinkFormatting",
                            children: [
                                {
                                    type: 0,
                                    value: "View details"
                                }
                            ]
                        }
                    ],
                    values: {
                        MediumFormatting: MediumFormatting,
                        IncentiveModalOpenLinkFormatting: OpenFaireDirectFirstOrderIncentiveModalButton,
                        percentageBasedNumber: formattedPercentageBasedNumber,
                        brandCompanyName: brandName !== null && brandName !== void 0 ? brandName : ""
                    }
                })
            });
        } else {
            return /*#__PURE__*/ _jsx(BannerWrapper, {
                children: /*#__PURE__*/ _jsx(StrictLocalMsg, {
                    id: "kTZptx",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "Get "
                        },
                        {
                            type: 1,
                            value: "percentageBasedNumber"
                        },
                        {
                            type: 0,
                            value: " off & free shipping with "
                        },
                        {
                            type: 1,
                            value: "brandCompanyName"
                        },
                        {
                            type: 0,
                            value: ". "
                        },
                        {
                            type: 8,
                            value: "IncentiveModalOpenLinkFormatting",
                            children: [
                                {
                                    type: 0,
                                    value: "View details"
                                }
                            ]
                        }
                    ],
                    values: {
                        IncentiveModalOpenLinkFormatting: OpenFaireDirectFirstOrderIncentiveModalButton,
                        percentageBasedNumber: formattedPercentageBasedNumber,
                        brandCompanyName: brandName !== null && brandName !== void 0 ? brandName : ""
                    }
                })
            });
        }
    }
    if (isLastDayBeforeExpiry) {
        return /*#__PURE__*/ _jsx(BannerWrapper, {
            children: /*#__PURE__*/ _jsx(StrictLocalMsg, {
                id: "ec4bOv",
                defaultMessage: [
                    {
                        type: 8,
                        value: "MediumFormatting",
                        children: [
                            {
                                type: 0,
                                value: "Last day!"
                            }
                        ]
                    },
                    {
                        type: 0,
                        value: " Get "
                    },
                    {
                        type: 1,
                        value: "promoMoney"
                    },
                    {
                        type: 0,
                        value: " off & free shipping with "
                    },
                    {
                        type: 1,
                        value: "brandCompanyName"
                    },
                    {
                        type: 0,
                        value: ". "
                    },
                    {
                        type: 8,
                        value: "IncentiveModalOpenLinkFormatting",
                        children: [
                            {
                                type: 0,
                                value: "View details"
                            }
                        ]
                    }
                ],
                values: {
                    MediumFormatting: MediumFormatting,
                    IncentiveModalOpenLinkFormatting: OpenFaireDirectFirstOrderIncentiveModalButton,
                    promoMoney: formattedFixedBasedAmount,
                    brandCompanyName: brandName !== null && brandName !== void 0 ? brandName : ""
                }
            })
        });
    } else if (isSecondLastDayBeforeExpiry) {
        return /*#__PURE__*/ _jsx(BannerWrapper, {
            children: /*#__PURE__*/ _jsx(StrictLocalMsg, {
                id: "M14xGb",
                defaultMessage: [
                    {
                        type: 8,
                        value: "MediumFormatting",
                        children: [
                            {
                                type: 0,
                                value: "2 days left!"
                            }
                        ]
                    },
                    {
                        type: 0,
                        value: " Get "
                    },
                    {
                        type: 1,
                        value: "promoMoney"
                    },
                    {
                        type: 0,
                        value: " off & free shipping with "
                    },
                    {
                        type: 1,
                        value: "brandCompanyName"
                    },
                    {
                        type: 0,
                        value: ". "
                    },
                    {
                        type: 8,
                        value: "IncentiveModalOpenLinkFormatting",
                        children: [
                            {
                                type: 0,
                                value: "View details"
                            }
                        ]
                    }
                ],
                values: {
                    MediumFormatting: MediumFormatting,
                    IncentiveModalOpenLinkFormatting: OpenFaireDirectFirstOrderIncentiveModalButton,
                    promoMoney: formattedFixedBasedAmount,
                    brandCompanyName: brandName !== null && brandName !== void 0 ? brandName : ""
                }
            })
        });
    } else {
        return /*#__PURE__*/ _jsx(BannerWrapper, {
            children: /*#__PURE__*/ _jsx(StrictLocalMsg, {
                id: "sceXEx",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Get "
                    },
                    {
                        type: 1,
                        value: "promoMoney"
                    },
                    {
                        type: 0,
                        value: " off & free shipping with "
                    },
                    {
                        type: 1,
                        value: "brandCompanyName"
                    },
                    {
                        type: 0,
                        value: ". "
                    },
                    {
                        type: 8,
                        value: "IncentiveModalOpenLinkFormatting",
                        children: [
                            {
                                type: 0,
                                value: "View details"
                            }
                        ]
                    }
                ],
                values: {
                    IncentiveModalOpenLinkFormatting: OpenFaireDirectFirstOrderIncentiveModalButton,
                    promoMoney: formattedFixedBasedAmount,
                    brandCompanyName: brandName !== null && brandName !== void 0 ? brandName : ""
                }
            })
        });
    }
};
export var FaireDirectFirstOrderIncentiveBanner = observer(FaireDirectFirstOrderIncentiveBannerBase);
var BannerWrapper = function(param) {
    var children = param.children;
    return /*#__PURE__*/ _jsx(Typography, {
        align: "center",
        "data-test-id": "faire-direct-first-order-incentive-banner",
        children: children
    });
};
